// extracted by mini-css-extract-plugin
export default {"page":"page--e0j5O","horizon":"horizon--Drdvs","horizon-img":"horizon-img--ysUm7","vertical":"vertical--BiykX","vertical-img":"vertical-img--PrSs1"};